<div class="community-map__input-controls">
    <form class="community-map__search">
        <mat-form-field role="search">
            <span matPrefix><mat-icon class="riege-icon">search</mat-icon></span>
            <input
                matInput
                placeholder="Search"
                i18n-placeholder="@@input-label-search"
                data-testid="btn-map-search"
                type="text"
                autoFocused
                aria-label="Search by name"
                i18n-aria-label="@@input-search-by-name"
                [formControl]="search"
                (keydown.enter)="$event.preventDefault()"
                [matAutocomplete]="auto" />
            <button
                matSuffix
                mat-icon-button
                class="riege-button riege-button--icon"
                *ngIf="search.value"
                #input
                type="button"
                aria-label="Reset search"
                i18n-aria-label="@@input-search-clear"
                (click)="search.reset(); input.focus()">
                <mat-icon class="riege-icon">close</mat-icon>
            </button>
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                <mat-option
                    *ngFor="let location of locations | async"
                    [value]="location['place_name']"
                    (onSelectionChange)="showLocation(location)">
                    {{ location['place_name'] }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </form>

    <riege-map-filter [buttons]="buttons" (buttonClicked)="setMapFilter($event)"> </riege-map-filter>
</div>

<div class="community-map__map" role="main">
    <riege-map
        #map
        [showControls]="true"
        [allowLocateUser]="true"
        [showScale]="true"
        [showReset]="true"
        [showZoom]="true"
        [center]="center"
        [zoom]="10"
        (mapMoved)="mapMoved()"></riege-map>
</div>
